import type { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REJECT_FARMER_TRANSFER_REQUEST_ASYNC,
    Actions.REJECT_FARMER_TRANSFER_REQUEST_SUCCESS,
    Actions.REJECT_FARMER_TRANSFER_REQUEST_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.REJECT_FARMER_TRANSFER_REQUEST_ASYNC:
    case Actions.REJECT_FARMER_TRANSFER_REQUEST_SUCCESS:
    case Actions.REJECT_FARMER_TRANSFER_REQUEST_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
